import api from "./api";

/*=====================
      save form data
======================*/
export const saveKioskSurveyApi = async (formData) => {
  return api.post("/save-maa-canteen-survey", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const saveKitchenSurveyApi = async (formData) => {
  return api.post("/save-maa-canteen-kitchen-survey", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export const saveKitchenDiningSurveyApi = async (formData) => {
  return api.post("/save-maa-canteen-kitchen-dining-survey", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


/*=====================
      get form data
======================*/

export const getKioskSurveyApi = async (canteenId, reportingDate) => {
  return api.get("/get-maa-canteen-survey", {
    params: {
      canteen_type_id: canteenId,
      ...(reportingDate && { reporting_date: reportingDate }),
    },
  });
};

export const getKitchenSurveyApi = async (canteenId, reportingDate) => {
  return api.get("/get-maa-canteen-kitchen-survey", {
    params: {
      canteen_type_id: canteenId,
      ...(reportingDate && { reporting_date: reportingDate }),
    },
  });
};

export const getKitchenDiningSurveyApi = async (canteenId, reportingDate) => {
  return api.get("/get-maa-canteen-kitchen-dining-survey", {
    params: {
      canteen_type_id: canteenId,
      ...(reportingDate && { reporting_date: reportingDate }),
    },
  });
};
